var _defs, _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient1"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "stop1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop2",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "stop3",
    offset: "100%"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    #check {\n      fill: url(#Gradient1);\n    }\n    .stop1 {\n      stop-color: #5acffa;\n    }\n    .stop2 {\n      stop-color: white;\n    }\n    .stop3 {\n      stop-color: #f5abb9;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M34.459 1.375a2.999 2.999 0 0 0-4.149.884L13.5 28.17l-8.198-7.58a2.999 2.999 0 1 0-4.073 4.405l10.764 9.952s.309.266.452.359a2.999 2.999 0 0 0 4.15-.884L35.343 5.524a2.999 2.999 0 0 0-.884-4.149z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.f4ea1c2993871cb792600e2ec474e182.svg";
export { ForwardRef as ReactComponent };